import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { Attestation, CompromiseReports } from "../../service/global.service";
import { DatePipe } from "@angular/common";
import { Backend } from 'src/app/backend-interface/backend';
import { TranslationService } from 'src/app/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';


/**
 * Child component which is shared part of Attestations modal/details && Compromise Reports part
 */
@Component({
    selector: 'app-modalpart',
    templateUrl: './modalpart.component.html',
    styleUrls: ['./modalpart.component.scss'],
    providers: [DatePipe, TranslationService],
    imports: [
      TranslateModule,
      NgbTooltipModule
    ],
    standalone: true
})
export class ModalpartComponent {
  @Input() objetCourant?: CompromiseReports | Attestation;
  @Output() filtreApp = new EventEmitter<string>();
  @Input() attestation?: boolean;
  @Output() eventMetadata = new EventEmitter<Map<any, any>>();

  public readonly translationService = inject(TranslationService);

  // Signals for translated values
  unknownLocationCountryCode = signal('');
  unknownAppInstallationDate = signal('');
  unknownModel = signal('');
  unknownLocationCity = signal('');
  unknownDevice = signal('');

  constructor(public datepipe: DatePipe) {
    this.translationService.get('unknown-location-country-code').subscribe(value => this.unknownLocationCountryCode.set(value));
    this.translationService.get('unknown-app-installation-date').subscribe(value => this.unknownAppInstallationDate.set(value));
    this.translationService.get('unknown-model').subscribe(value => this.unknownModel.set(value));
    this.translationService.get('unknown-location-city').subscribe(value => this.unknownLocationCity.set(value));
    this.translationService.get('unknown-device').subscribe(value => this.unknownDevice.set(value));
  }

  getApp() {
    this.filtreApp.emit(this.objetCourant?.appInfo?.appName);
  }

  getContrycode() {
    return this.objetCourant?.location?.countryCode ?? this.unknownLocationCountryCode();
  }

  getApptimeStamp() {
    if (this.objetCourant?.appInfo?.appInstallationTimestamp) {
      let date = new Date(this.objetCourant.appInfo.appInstallationTimestamp * 1000);
      return this.datepipe.transform(date, 'dd/MM/yyyy');
    }
    return this.unknownAppInstallationDate();
  }

  modelMarque() {
    let model = this.objetCourant?.deviceInfo?.model?.toLowerCase();
    if (!model) return this.unknownModel();
    const brands = ['google', 'samsung', 'asus', 'honor', 'huawei', 'vivo', 'lg', 'xiaomi', 'htc', 'oneplus', 'nokia', 'sony', 'motorola'];
    for (const brand of brands) {
      if (model.includes(brand)) {
        return brand;
      }
    }
    return this.unknownModel();
  }

  formatLongString(chaine: string | undefined) {
    return Backend.FORMAT.formatN(chaine, 18);
  }

  formatVersion(chaine: string | undefined) {
    let format = chaine;
    if (format && format.length > 7) {
      format = format.slice(0, 7) + '...';
    }
    return format;
  }

  formatType(bwCompromiseType: any) {
    if (bwCompromiseType) {
      return bwCompromiseType.toLowerCase().replaceAll(/ |-|_|ko/g, '');
    }
    return '';
  }

  formatKernelVersion() {
    let format = this.objetCourant?.deviceInfo?.kernelVersion;
    if (format) {
      format = format.replace(/[/#: -].*$/, '...');
    }
    return format;
  }

  getCity() {
    return this.objetCourant?.location?.city ?? this.unknownLocationCity();
  }

  formatName(model: string | undefined) {
    let mod = this.unknownDevice();
    if (model && model !== this.unknownDevice()) {
      mod = model[0].toUpperCase() + model.slice(1);
    }
    return mod;
  }

  getlength(string: string | undefined) {
    return string?.length ?? 0;
  }

  attestationType() {
    return Object.prototype.toString.apply(this.objetCourant);
  }

  getMetaData() {
    let attestationTempo = this.objetCourant as Attestation;
    return attestationTempo?.metadata ? new Map(Object.entries(attestationTempo.metadata)) : undefined;
  }

  emitMetadata() {
    this.eventMetadata.emit(this.getMetaData());
  }
}
